// Components==============
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './Spinner.module.scss';
// =========================

export default function Spinner({
  loading = true,
  style,
  fullPage,
}: {
  loading?: boolean;
  style?: React.CSSProperties;
  fullPage?: boolean;
}) {
  if (!loading) return <></>;

  return (
    <div style={style} styleName={`spinner ${fullPage ? 'full-page' : ''}`}>
      <FontAwesomeIcon icon={faSpinnerThird} spin />
    </div>
  );
}
